module.exports = __webpack_public_path__ + "static/media/23.8046b57f.jpg";